export const environment = {
  production: false,
  api: {
    baseUrl: '',
    authServerUrl: 'https://dev-auth.psycocenter.com',
    oauth2TokenUrl: '/oauth2/token',
    clientId: 'simplified-client',
    clientSecret: 'simplified',
    redirectUri: 'https://dev-admin.psycocenter.com/callback',
    scopes:
      'openid person:read person:write role:read role:write permission:read permission:write scope:read scope:write client:read client:write',
  },
} as const;
